import { fromJS } from 'immutable';
import actions from '../constants';

const initialState = fromJS({});

const update = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_FINISH:
      return fromJS(action.payload.coding || {});
    case actions.GET_ERROR:
      return fromJS({});
    case actions.CREATE_FINISH:
      return state.set(action.payload.id, fromJS(action.payload.entity));
    case actions.DELETE_FINISH:
      return state.delete(action.payload.codingId);
    case actions.UPDATE_FINISH:
      return state.update(action.payload.codingId, coding =>
        coding.merge(fromJS(action.payload.entity))
      );
    default:
      return state;
  }
};

export default update;



// WEBPACK FOOTER //
// ./src/modules/coding/reducers/entities.js